import { render, staticRenderFns } from "./GAvatar.vue?vue&type=template&id=a7513f70&"
import script from "./GAvatar.vue?vue&type=script&lang=js&"
export * from "./GAvatar.vue?vue&type=script&lang=js&"
import style0 from "./GAvatar.vue?vue&type=style&index=0&id=a7513f70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports